import {
    SHOW_INDICES_POPUP,
    HIDE_INDICES_POPUP,
    ALL_INDICES_REQUEST,
    ALL_INDICES_SUCCESS,
    ALL_INDICES_FAIL,
    ADD_INDEX,
    INDEX_SETTLEMENT_REQUEST,
    INDEX_SETTLEMENT_SUCCESS,
    INDEX_SETTLEMENT_FAIL,
    INDEX_SETTLEMENT_REPORT_REQUEST,
    INDEX_SETTLEMENT_REPORT_SUCCESS,
    INDEX_SETTLEMENT_REPORT_FAIL,
    SHOW_POPUP,
    GET_SCHEDULE_REQUEST,
    GET_SCHEDULE_SUCCESS,
    GET_SCHEDULE_FAIL,
    SAVE_SCHEDULE_REQUEST,
    SET_MARKET_ID,
    SET_INDICES_YEAR,
    SET_SELECTED_DATE,
    SET_SELECTED_FREQUENCY_TYPE,
    SET_SCHEDULE_UPDATED,
    INDICES_MARKETS_LIST_REQUEST,
    INDICES_MARKETS_LIST_SUCCESS,
    INDICES_MARKETS_LIST_FAIL,
    SET_INDICES_MODAL_SETTING,
} from '../constants/action-types';
import { IndicesFrequency } from '../constants/indices';

import {
    getAllIndicesRequest,
    addIndexRequest,
    getScheduleRequest,
    saveScheduleRequest,
    indexSettlementRequest,
    indexSettlementReportRequest,
    getMarketsAllRequest,
} from '../services/api';

import { cutDate, isLaterThanWeekAfterToday } from '../services/utils';

export function showIndicesPopup() {
    return {
        type: SHOW_INDICES_POPUP,
    };
}
export function hideIndicesPopup() {
    return {
        type: HIDE_INDICES_POPUP,
    };
}

export function getAllIndices() {
    return dispatch => {
        getAllIndicesRefresh(dispatch);
    };
}

export function addIndex(params) {
    return dispatch => {
        dispatch({ type: ADD_INDEX });
        return addIndexRequest(params)
            .then(result => {
                getAllIndicesRefresh(dispatch);
            })
            .catch(error => {
                console.log('add index error', error);
            });
    };
}

export function sendSettlement(params) {
    return dispatch => {
        dispatch({ type: INDEX_SETTLEMENT_REQUEST });
        return indexSettlementRequest(params)
            .then(result => {
                dispatch({ type: INDEX_SETTLEMENT_REPORT_SUCCESS });
                dispatch({
                    type: SHOW_POPUP,
                    popupProps: {
                        title: 'Success',
                        content: 'Index report was sent to your email.',
                        buttonText: 'Ok',
                    },
                });
            })
            .catch(error => {
                dispatch({ type: INDEX_SETTLEMENT_FAIL });
                const { status, data } = error.response;
                if (status !== 417) {
                    dispatch({
                        type: SHOW_POPUP,
                        popupProps: {
                            title: 'Error',
                            content:
                                data.toString() ||
                                'Something went wrong. Perhaps there are no indices for chosen period',
                            buttonText: 'Ok',
                        },
                    });
                }
            });
    };
}

export function sendSettlementReport(params) {
    return dispatch => {
        dispatch({ type: INDEX_SETTLEMENT_REPORT_REQUEST });
        return indexSettlementReportRequest(params)
            .then(result => {
                dispatch({ type: INDEX_SETTLEMENT_SUCCESS });
                dispatch({
                    type: SHOW_POPUP,
                    popupProps: {
                        title: 'Success',
                        content: 'Settlement report was sent to your email.',
                        buttonText: 'Ok',
                    },
                });
            })
            .catch(error => {
                const { status } = error.response;
                dispatch({ type: INDEX_SETTLEMENT_REPORT_FAIL });
                if (status !== 417) {
                    dispatch({
                        type: SHOW_POPUP,
                        popupProps: {
                            title: 'Fail',
                            content: 'Something went wrong. Perhaps there is no indices for chosen period.',
                            buttonText: 'Ok',
                        },
                    });
                }
            });
    };
}

const transformData = data => {
    const results = data.reduce((agg, item) => {
        return {
            ...agg,
            [item.product_id]: {
                ...agg[item.product_id],
                [cutDate(item.created_date)]: item,
            },
        };
    }, {});

    return results;
};

const getAllIndicesRefresh = async dispatch => {
    dispatch({ type: ALL_INDICES_REQUEST });
    try {
        const result = await getAllIndicesRequest();
        dispatch({
            type: ALL_INDICES_SUCCESS,
            payload: transformData(result.data),
        });
    } catch (error) {
        dispatch({
            type: ALL_INDICES_FAIL,
        });
    }
};

export function getSchedule(marketId, year, setDates) {
    return dispatch => {
        dispatch({ type: GET_SCHEDULE_REQUEST });
        return getScheduleRequest(marketId, year)
            .then(result => {
                dispatch({
                    type: GET_SCHEDULE_SUCCESS,
                    payload: result.data.reverse(),
                });
                if (typeof setDates == 'function') {
                    setDates(result.data[0].selectedDates);
                }
            })
            .catch(error => {
                dispatch({ type: GET_SCHEDULE_FAIL });
                console.log(error);
            });
    };
}

export function saveSchedule(marketId, year, selectedDays, frequencyType, isBlank) {
    const successPopup = {
        type: SHOW_POPUP,
        popupProps: {
            title: 'Success',
            content: 'Schedule was saved',
        },
    };
    const saveReq = dispatch => {
        dispatch({ type: SAVE_SCHEDULE_REQUEST });
        let transformed = selectedDays.map(item => item.toString());
        return saveScheduleRequest(marketId, year, transformed, frequencyType)
            .then(result => {
                dispatch(successPopup);
            })
            .catch(error => console.log(error));
    };
    return dispatch => {
        if (isBlank) {
            saveReq(dispatch);
            dispatch(successPopup);
        } else {
            dispatch({
                type: SHOW_POPUP,
                popupProps: {
                    title: 'Are you sure?',
                    content: 'Previous version of schedule would be replaced',
                    isConfirm: true,
                    buttonAction: () => {
                        saveReq(dispatch);
                    },
                },
            });
        }
    };
}

export function setMarketId(id) {
    return {
        type: SET_MARKET_ID,
        market_id: id,
    };
}
export function setYear(year) {
    return {
        type: SET_INDICES_YEAR,
        year,
    };
}

export function setSelectedDate(date) {
    return {
        type: SET_SELECTED_DATE,
        selected_date: date,
    };
}
export function scheduleShouldBeUpdated(value) {
    return {
        type: SET_SCHEDULE_UPDATED,
        value,
    };
}

export const getMarketsListWithProducts = () => async dispatch => {
    dispatch({ type: INDICES_MARKETS_LIST_REQUEST });
    try {
        const result = await getMarketsAllRequest(false);

        dispatch({
            type: INDICES_MARKETS_LIST_SUCCESS,
            payload: result.data,
        });
    } catch (error) {
        dispatch({ type: INDICES_MARKETS_LIST_FAIL, error });
    }
};

export const getFullSchedule = (marketId, year) => async dispatch => {
    dispatch({ type: GET_SCHEDULE_REQUEST });
    try {
        const [{ data: weeklyResult }, { data: dailyResult }] = await Promise.all([
            getScheduleRequest(marketId, year, IndicesFrequency.WEEKLY, 'desc'),
            getScheduleRequest(marketId, year, IndicesFrequency.DAILY, 'desc'),
        ]);
        dispatch({
            type: GET_SCHEDULE_SUCCESS,
            payload: {
                [IndicesFrequency.DAILY]: dailyResult ? dailyResult[0] : {},
                [IndicesFrequency.WEEKLY]: weeklyResult ? weeklyResult[0] : {},
            },
        });
    } catch (error) {
        dispatch({ type: GET_SCHEDULE_FAIL });
    }
};

export const getScheduleV2 = (marketId, year, frequencyType, setDates) => async dispatch => {
    dispatch({ type: GET_SCHEDULE_REQUEST });
    try {
        const result = await getScheduleRequest(marketId, year, frequencyType, 'desc');
        dispatch({
            type: GET_SCHEDULE_SUCCESS,
            payload: {
                [frequencyType]: result.data ? result.data[0] : {},
            },
        });
        if (typeof setDates === 'function') {
            setDates(result.data[0].selectedDates);
        }
    } catch (error) {
        dispatch({ type: GET_SCHEDULE_FAIL });
    }
};

export const setFrequencyType = frequencyType => ({
    type: SET_SELECTED_FREQUENCY_TYPE,
    frequencyType,
});

export const setIndicesModalSettings = (market_id, year, frequencyType, selected_date) => ({
    type: SET_INDICES_MODAL_SETTING,
    payload: { market_id, year, frequencyType, selected_date },
});

export const getProductsIndices = (marketId, year, frequencyType) => async (dispatch, getState) => {
    await dispatch(getFullSchedule(marketId, year, frequencyType));

    const { indicesShedule } = getState().indices;
    const selectedDates = (indicesShedule[frequencyType] && indicesShedule[frequencyType].selectedDates) || [];
    const selectedDate = selectedDates.filter(d => !isLaterThanWeekAfterToday(d))[0];

    dispatch(setIndicesModalSettings(marketId, year, frequencyType, selectedDate));
};



// WEBPACK FOOTER //
// ./source/actions/indicesActions.js